/* Base Template - theme.js */
(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     Header: trasparente -> bianco allo scroll, ricerca, drawer mobile
  --------------------------------------------------------------- */
  var headerScrollBound = false;

  function initHeader(scope) {
    qsa('[data-fg-header]', scope).forEach(function (header) {
      if (header.dataset.init) return;
      header.dataset.init = '1';

      var drawer = qs('[data-drawer]', header);
      var burger = qs('[data-burger]', header);
      var search = qs('[data-search]', header);
      var searchInput = qs('[data-search-input]', header);

      function onScroll() { header.classList.toggle('is-scrolled', window.scrollY > 10); }
      onScroll();
      if (!headerScrollBound) {
        headerScrollBound = true;
        window.addEventListener('scroll', function () {
          qsa('[data-fg-header]').forEach(function (h) { h.classList.toggle('is-scrolled', window.scrollY > 10); });
        }, { passive: true });
      }

      function closeDrawer() {
        if (!drawer) return;
        drawer.hidden = true;
        document.body.classList.remove('no-scroll');
        if (burger) burger.setAttribute('aria-expanded', 'false');
      }
      function openDrawer() {
        if (!drawer) return;
        drawer.hidden = false;
        document.body.classList.add('no-scroll');
        if (burger) burger.setAttribute('aria-expanded', 'true');
      }
      function closeSearch() {
        if (!search) return;
        search.hidden = true;
        header.classList.remove('is-open');
      }
      function openSearch() {
        if (!search) return;
        search.hidden = false;
        header.classList.add('is-open');
        if (searchInput) setTimeout(function () { searchInput.focus(); }, 30);
      }

      if (burger) burger.addEventListener('click', openDrawer);
      qsa('[data-burger-close]', header).forEach(function (el) { el.addEventListener('click', closeDrawer); });
      qsa('[data-search-open]', header).forEach(function (el) {
        el.addEventListener('click', function () { if (search && search.hidden) openSearch(); else closeSearch(); });
      });
      qsa('[data-search-close]', header).forEach(function (el) { el.addEventListener('click', closeSearch); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeSearch(); closeDrawer(); }
      });
    });
  }

  /* ---------------------------------------------------------------
     Slideshow
  --------------------------------------------------------------- */
  function initSlideshow(scope) {
    qsa('[data-fg-slideshow]', scope).forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';

      var slides = qsa('.fgs__slide', root);
      var dots = qsa('[data-dot]', root);
      if (slides.length < 2) return;

      var index = 0;
      var timer = null;
      var interval = (parseInt(root.dataset.interval, 10) || 6) * 1000;
      var autoplay = root.dataset.autoplay === 'true' && !reduceMotion;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
      }
      function next() { show(index + 1); }
      function prev() { show(index - 1); }
      function start() { if (autoplay) { stop(); timer = setInterval(next, interval); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      var btnNext = qs('[data-next]', root);
      var btnPrev = qs('[data-prev]', root);
      if (btnNext) btnNext.addEventListener('click', function () { next(); start(); });
      if (btnPrev) btnPrev.addEventListener('click', function () { prev(); start(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(parseInt(d.dataset.dot, 10)); start(); });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) { if (dx < 0) next(); else prev(); start(); }
        x0 = null;
      });

      // nell'editor: mostra la slide selezionata
      root.addEventListener('shopify:block:select', function (e) {
        var i = slides.indexOf(e.target);
        if (i > -1) { stop(); show(i); }
      });
      root.addEventListener('shopify:block:deselect', start);

      start();
    });
  }

  /* ---------------------------------------------------------------
     Novita: tab + frecce del carosello
  --------------------------------------------------------------- */
  function initArrivals(scope) {
    qsa('[data-fg-arrivals]', scope).forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';

      var tabs = qsa('[data-tab]', root);
      var panels = qsa('[data-panel]', root);
      var cta = qs('[data-cta]', root);

      function updateArrows(panel) {
        var track = qs('[data-track]', panel);
        if (!track) return;
        var prev = qs('[data-arrow="-1"]', panel);
        var next = qs('[data-arrow="1"]', panel);
        var max = track.scrollWidth - track.clientWidth - 4;
        if (prev) prev.hidden = track.scrollLeft <= 4;
        if (next) next.hidden = track.scrollLeft >= max || max <= 0;
      }

      function activate(id) {
        tabs.forEach(function (t) {
          var on = t.dataset.tab === id;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.dataset.panel === id;
          p.hidden = !on;
          if (on) {
            if (cta && p.dataset.url) cta.setAttribute('href', p.dataset.url);
            updateArrows(p);
          }
        });
      }

      tabs.forEach(function (t) { t.addEventListener('click', function () { activate(t.dataset.tab); }); });

      panels.forEach(function (p) {
        var track = qs('[data-track]', p);
        if (!track) return;
        track.addEventListener('scroll', function () { updateArrows(p); }, { passive: true });
        qsa('[data-arrow]', p).forEach(function (b) {
          b.addEventListener('click', function () {
            var dir = parseInt(b.dataset.arrow, 10);
            track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
          });
        });
        updateArrows(p);
      });
      window.addEventListener('resize', function () {
        var active = panels.filter(function (p) { return !p.hidden; })[0];
        if (active) updateArrows(active);
      });

      root.addEventListener('shopify:block:select', function (e) {
        var id = e.target && e.target.dataset ? e.target.dataset.tab : null;
        if (id) activate(id);
      });
    });
  }

  /* ---------------------------------------------------------------
     Footer: tab Trending + pillole
  --------------------------------------------------------------- */
  function initFooter(scope) {
    qsa('[data-fg-footer]', scope).forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';

      var tabs = qsa('.fgf__tab', root);
      var panels = qsa('.fgf__tabpanel', root);

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
          panels.forEach(function (p) { p.hidden = p.dataset.panel !== t.dataset.tab; });
        });
      });

      panels.forEach(function (panel) {
        var pills = qsa('.fgf__pill', panel);
        var lists = qsa('.fgf__links', panel);
        pills.forEach(function (pill) {
          pill.addEventListener('click', function () {
            pills.forEach(function (x) { x.classList.toggle('is-active', x === pill); });
            lists.forEach(function (l) { l.hidden = l.dataset.links !== pill.dataset.pill; });
          });
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     Pagina prodotto: varianti, prezzo, barra fissa, foto ingrandita
  --------------------------------------------------------------- */
  function initProduct(scope) {
    qsa('[data-fg-product]', scope).forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';

      var wrap = root.parentNode;
      var select = qs('[data-variant-select]', root);
      var radios = qsa('[data-variant-radio]', root);
      var priceBox = qs('[data-price]', root);
      var btn = qs('[data-add]', root);
      var sticky = qs('[data-sticky]', wrap);
      var stickyBtn = sticky ? qs('[data-sticky-add]', sticky) : null;
      var stickyPrice = sticky ? qs('[data-sticky-price]', sticky) : null;

      function readSelected() {
        if (select) {
          var opt = select.options[select.selectedIndex];
          return { el: opt, id: select.value, title: opt.textContent.replace(/ - [^-]*$/, '').trim() };
        }
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].checked) {
            var span = radios[i].parentNode.querySelector('span');
            return { el: radios[i], id: radios[i].value, title: span ? span.textContent.trim() : '' };
          }
        }
        return null;
      }

      function apply() {
        var cur = readSelected();
        if (!cur) return;
        var d = cur.el.dataset;
        var ok = d.available === 'true';

        if (priceBox) {
          priceBox.innerHTML =
            (d.compare ? '<s>' + d.compare + '</s>' : '') +
            '<span data-price-now>' + d.price + '</span>' +
            '<span class="fgp__save" data-save' + (d.save ? '' : ' hidden') + '>' + (d.save || '') + '</span>';
        }
        if (btn) {
          btn.disabled = !ok;
          btn.textContent = ok ? btn.dataset.labelAdd : btn.dataset.labelSold;
        }
        if (stickyBtn) {
          stickyBtn.disabled = !ok;
          stickyBtn.textContent = ok ? btn.dataset.labelAdd : btn.dataset.labelSold;
        }
        if (stickyPrice) stickyPrice.textContent = d.price;

        if (window.history && history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', cur.id);
            history.replaceState({}, '', url.toString());
          } catch (e) {}
        }

        document.dispatchEvent(new CustomEvent('fg:variant-change', {
          detail: { id: cur.id, cents: parseInt(d.cents, 10), title: cur.title }
        }));
      }

      if (select) select.addEventListener('change', apply);
      radios.forEach(function (r) { r.addEventListener('change', apply); });

      /* Barra fissa: compare quando il bottone esce dallo schermo verso l'alto */
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.hidden = !(!e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(btn);
        if (stickyBtn) stickyBtn.addEventListener('click', function () { if (!btn.disabled) btn.click(); });
      }

      /* Foto ingrandita */
      var lb = qs('[data-lightbox]', wrap);
      var zoomers = qsa('[data-zoom]', root);
      if (lb && zoomers.length) {
        var lbImg = qs('.fglb__img', lb);
        var idx = 0;
        function show(i) {
          idx = (i + zoomers.length) % zoomers.length;
          lbImg.src = zoomers[idx].dataset.zoom;
          lbImg.alt = zoomers[idx].dataset.alt || '';
        }
        function openLb(i) { show(i); lb.hidden = false; document.body.classList.add('no-scroll'); }
        function closeLb() { lb.hidden = true; lbImg.removeAttribute('src'); document.body.classList.remove('no-scroll'); }
        zoomers.forEach(function (z, i) { z.addEventListener('click', function () { openLb(i); }); });
        qs('[data-lb-close]', lb).addEventListener('click', closeLb);
        qs('[data-lb-prev]', lb).addEventListener('click', function () { show(idx - 1); });
        qs('[data-lb-next]', lb).addEventListener('click', function () { show(idx + 1); });
        lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
        document.addEventListener('keydown', function (e) {
          if (lb.hidden) return;
          if (e.key === 'Escape') closeLb();
          if (e.key === 'ArrowLeft') show(idx - 1);
          if (e.key === 'ArrowRight') show(idx + 1);
        });
        if (zoomers.length < 2) {
          qs('[data-lb-prev]', lb).hidden = true;
          qs('[data-lb-next]', lb).hidden = true;
        }
      }
    });
  }

  /* ---------------------------------------------------------------
     Filtri collezione/ricerca: drawer, invio automatico, ordinamento
  --------------------------------------------------------------- */
  function initFilters(scope) {
    qsa('[data-fg-filters]', scope).forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';
      var drawer = qs('[data-filter-drawer]', root);
      var form = qs('[data-filter-form]', root);
      var sort = qs('[data-sort-select]', root);
      var timer = null;

      function open() { if (!drawer) return; drawer.hidden = false; document.body.classList.add('no-scroll'); }
      function close() { if (!drawer) return; drawer.hidden = true; document.body.classList.remove('no-scroll'); }

      qsa('[data-filter-open]', root).forEach(function (b) { b.addEventListener('click', open); });
      qsa('[data-filter-close]', root).forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

      function go() {
        if (!form) return;
        qsa('input[type="number"]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
        form.submit();
      }

      if (form) {
        form.addEventListener('submit', function () {
          qsa('input[type="number"]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
        });
        form.addEventListener('change', function (e) {
          var t = e.target;
          if (t && t.type === 'checkbox') { clearTimeout(timer); timer = setTimeout(go, 250); }
        });
      }
      if (sort) sort.addEventListener('change', go);
    });
  }

  /* ---------------------------------------------------------------
     Utilita comuni: formato prezzo, card prodotto, consigli Shopify
  --------------------------------------------------------------- */
  var moneyFmt = (function () {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: cur }); }
    catch (e) { return new Intl.NumberFormat('it', { style: 'currency', currency: 'EUR' }); }
  })();
  function money(cents) { return moneyFmt.format(cents / 100); }

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    var abs = url.indexOf('//') === 0 ? 'https:' + url : url;
    return abs + (abs.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function baseUrl(root) { return ((root && root.dataset.root) || '/').replace(/\/$/, ''); }

  function fetchProductByHandle(base, handle) {
    return fetch(base + '/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* Chiede a Shopify i prodotti consigliati e li scarica (dati completi) */
  function fetchRecommended(root, limit, intent) {
    var url = root.dataset.recUrl + '.json?product_id=' + encodeURIComponent(root.dataset.productId) +
      '&limit=' + limit + '&intent=' + intent;
    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var list = (data && data.products) || [];
        return Promise.all(list.map(function (p) { return fetchProductByHandle(baseUrl(root), p.handle); }));
      })
      .then(function (items) { return items.filter(Boolean); })
      .catch(function () { return []; });
  }

  var WL_BTN = '<button type="button" class="fgwl" data-wishlist data-handle="__H__" aria-pressed="false" aria-label="Aggiungi ai preferiti"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.7c0 5.6-7.5 10.2-7.5 10.2Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></button>';

  function buildCard(p, tapeTpl) {
    var el = document.createElement('div');
    el.className = 'fgc' + (p.available ? '' : ' is-soldout');
    var img = p.featured_image
      ? '<img class="fgc__img fgc__img1" src="' + esc(sized(p.featured_image, 800)) + '" alt="' + esc(p.title) + '" loading="lazy">'
      : '';
    el.innerHTML =
      '<div class="fgc__media"><a class="fgc__link" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' + img + '</a>' + WL_BTN.replace('__H__', esc(p.handle)) + '</div>' +
      '<a class="fgc__info" href="' + esc(p.url) + '">' +
        (p.vendor ? '<span class="fgc__brand">' + esc(p.vendor) + '</span>' : '') +
        '<span class="fgc__title">' + esc(p.title) + '</span>' +
        '<span class="fgc__price">' + esc(money(p.price)) + '</span>' +
      '</a>';
    if (!p.available && tapeTpl) el.querySelector('.fgc__media').appendChild(tapeTpl.content.cloneNode(true));
    return el;
  }

  /* Potrebbe piacerti anche */
  function initRelated(scope) {
    qsa('[data-fg-related]', scope).forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';
      var grid = qs('[data-grid]', root);
      var tpl = qs('[data-tape-tpl]', root);
      var limit = parseInt(root.dataset.limit, 10) || 6;
      fetchRecommended(root, limit, 'related').then(function (items) {
        if (!items.length) return;
        items.slice(0, limit).forEach(function (p) { grid.appendChild(buildCard(p, tpl)); });
        root.hidden = false;
      });
    });
  }

  /* Visti di recente (salvati nel browser) */
  function initRecent(scope) {
    qsa('[data-fg-recent]', scope).forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';
      var KEY = 'fg_recently_viewed';
      var limit = parseInt(root.dataset.limit, 10) || 4;
      var current = root.dataset.handle;
      var list = [];
      try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
      if (!Array.isArray(list)) list = [];
      if (current) {
        list = [current].concat(list.filter(function (h) { return h !== current; })).slice(0, 20);
        try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      }
      var handles = list.filter(function (h) { return h !== current; }).slice(0, limit);
      if (!handles.length) return;
      var grid = qs('[data-grid]', root);
      var tpl = qs('[data-tape-tpl]', root);
      Promise.all(handles.map(function (h) { return fetchProductByHandle(baseUrl(root), h); })).then(function (items) {
        items = items.filter(Boolean);
        if (!items.length) return;
        items.forEach(function (p) { grid.appendChild(buildCard(p, tpl)); });
        root.hidden = false;
      });
    });
  }

  /* Acquistati spesso insieme */
  function initBundle(scope) {
    qsa('[data-fg-bundle]', scope).forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';

      var recBox = qs('[data-bundle-rec]', root);
      var totalEl = qs('[data-bundle-total]', root);
      var countEl = qs('[data-bundle-count]', root);
      var addBtn = qs('[data-bundle-add]', root);
      var msgEl = qs('[data-bundle-msg]', root);
      var mainBox = qs('[data-bundle-main]', root);
      var mainPriceEl = qs('[data-bundle-main-price]', root);
      var mainVariantEl = qs('[data-bundle-main-variant]', root);
      var max = parseInt(root.dataset.max, 10) || 2;

      function mainVariantId() {
        var el = document.querySelector('.fgp__form [name="id"]:checked') ||
                 document.querySelector('.fgp__form select[name="id"]') ||
                 document.querySelector('.fgp__form input[name="id"][type="hidden"]');
        return el ? el.value : mainBox.dataset.variant;
      }

      function items() {
        var list = [{ id: mainVariantId(), cents: parseInt(mainBox.dataset.cents, 10) || 0 }];
        qsa('[data-bundle-item]', recBox).forEach(function (it) {
          var check = qs('[data-bundle-check]', it);
          if (check && check.checked) list.push({ id: it.dataset.variant, cents: parseInt(it.dataset.cents, 10) || 0 });
        });
        return list;
      }

      function refresh() {
        var list = items();
        totalEl.textContent = money(list.reduce(function (a, b) { return a + b.cents; }, 0));
        countEl.textContent = list.length;
        addBtn.disabled = list.length < 2;
      }

      document.addEventListener('fg:variant-change', function (e) {
        var d = e.detail || {};
        if (d.cents != null && !isNaN(d.cents)) { mainBox.dataset.cents = d.cents; mainPriceEl.textContent = money(d.cents); }
        if (d.id) mainBox.dataset.variant = d.id;
        if (mainVariantEl && d.title) mainVariantEl.textContent = d.title;
        refresh();
      });

      recBox.addEventListener('change', function (e) {
        var t = e.target;
        var it = t.closest('[data-bundle-item]');
        if (!it) return;
        if (t.matches('[data-bundle-select]')) {
          var opt = t.options[t.selectedIndex];
          it.dataset.variant = t.value;
          it.dataset.cents = opt.dataset.cents;
          qs('.fgb__price', it).textContent = money(parseInt(opt.dataset.cents, 10));
        }
        it.classList.toggle('is-off', !qs('[data-bundle-check]', it).checked);
        refresh();
      });

      addBtn.addEventListener('click', function () {
        var list = items();
        if (list.length < 2) return;
        addBtn.disabled = true;
        msgEl.textContent = '';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: list.map(function (i) { return { id: parseInt(i.id, 10), quantity: 1 }; }) })
        }).then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        }).then(function (res) {
          if (res.ok) { window.location.href = root.dataset.cartUrl; }
          else {
            msgEl.textContent = res.data.description || res.data.message || 'Impossibile aggiungere i prodotti.';
            addBtn.disabled = false;
          }
        }).catch(function () {
          msgEl.textContent = 'Errore di connessione, riprova.';
          addBtn.disabled = false;
        });
      });

      fetchRecommended(root, 8, root.dataset.intent || 'complementary').then(function (items) {
        var shown = 0;
        items.forEach(function (p) {
          if (shown >= max || !p.available) return;
          var first = null;
          for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { first = p.variants[i]; break; } }
          if (!first) return;
          shown++;

          var plus = document.createElement('div');
          plus.className = 'fgb__plus';
          plus.setAttribute('aria-hidden', 'true');
          plus.textContent = '+';

          var el = document.createElement('div');
          el.className = 'fgb__item';
          el.setAttribute('data-bundle-item', '');
          el.dataset.cents = first.price;
          el.dataset.variant = first.id;

          var options = '';
          if (p.variants.length > 1) {
            options = '<select class="fgb__select" data-bundle-select aria-label="Variante di ' + esc(p.title) + '">' +
              p.variants.filter(function (v) { return v.available; }).map(function (v) {
                return '<option value="' + v.id + '" data-cents="' + v.price + '"' + (v.id === first.id ? ' selected' : '') + '>' + esc(v.title) + '</option>';
              }).join('') + '</select>';
          }

          el.innerHTML =
            '<label class="fgb__check"><input type="checkbox" checked data-bundle-check aria-label="Includi ' + esc(p.title) + '"><span class="fgb__box" aria-hidden="true"></span></label>' +
            '<a class="fgb__img" href="' + esc(p.url) + '" tabindex="-1">' +
              (p.featured_image ? '<img src="' + esc(sized(p.featured_image, 500)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="fgb__meta">' +
              (p.vendor ? '<span class="fgb__brand">' + esc(p.vendor) + '</span>' : '') +
              '<a class="fgb__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
              options +
              '<span class="fgb__price">' + esc(money(first.price)) + '</span>' +
            '</div>';

          recBox.appendChild(plus);
          recBox.appendChild(el);
        });
        if (shown > 0) { root.hidden = false; refresh(); }
      });
    });
  }

  /* ---------------------------------------------------------------
     Pagina Designer: ricerca brand
  --------------------------------------------------------------- */
  function initBrands(scope) {
    qsa('[data-fg-brands]', scope).forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';
      var input = qs('[data-brand-search]', root);
      if (!input) return;
      var items = qsa('[data-brand-item]', root);
      var groups = qsa('[data-brand-group]', root);
      var none = qs('[data-brand-none]', root);
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        items.forEach(function (li) { li.hidden = q !== '' && li.dataset.name.indexOf(q) === -1; });
        var any = false;
        groups.forEach(function (g) {
          var visible = qsa('[data-brand-item]', g).some(function (li) { return !li.hidden; });
          g.hidden = !visible;
          if (visible) any = true;
        });
        if (none) none.hidden = any;
      });
    });
  }

  /* Preferiti (salvati nel browser) */
  var WL_KEY = 'fg_wishlist';
  function wlGet() {
    var l = [];
    try { l = JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { l = []; }
    return Array.isArray(l) ? l : [];
  }
  function wlSet(l) { try { localStorage.setItem(WL_KEY, JSON.stringify(l)); } catch (e) {} }
  function wlRefresh(scope) {
    var list = wlGet();
    qsa('[data-wishlist]', scope || document).forEach(function (b) {
      var on = list.indexOf(b.dataset.handle) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Togli dai preferiti' : 'Aggiungi ai preferiti');
    });
    qsa('[data-wishlist-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
  }
  var wlBound = false;
  function initWishlist(scope) {
    wlRefresh(scope);
    if (wlBound) return;
    wlBound = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-wishlist]') : null;
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var h = b.dataset.handle;
      var list = wlGet();
      var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.unshift(h);
      wlSet(list);
      wlRefresh(document);
      document.dispatchEvent(new CustomEvent('fg:wishlist-change', { detail: { handle: h, on: i === -1 } }));
    });
    window.addEventListener('storage', function () { wlRefresh(document); });
  }

  /* Pagina Preferiti */
  function initWishlistPage(scope) {
    qsa('[data-fg-wishlist]', scope).forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';
      var grid = qs('[data-grid]', root);
      var empty = qs('[data-empty]', root);
      var tpl = qs('[data-tape-tpl]', root);
      function render() {
        var handles = wlGet();
        grid.innerHTML = '';
        if (!handles.length) { empty.hidden = false; return; }
        empty.hidden = true;
        Promise.all(handles.map(function (h) { return fetchProductByHandle(baseUrl(root), h); })).then(function (items) {
          items.filter(Boolean).forEach(function (p) { grid.appendChild(buildCard(p, tpl)); });
          wlRefresh(grid);
        });
      }
      render();
      document.addEventListener('fg:wishlist-change', function (ev) {
        if (!ev.detail.on) {
          var card = qs('[data-handle="' + ev.detail.handle + '"]', grid);
          if (card) { var c = card.closest('.fgc'); if (c) c.remove(); }
          if (!wlGet().length) empty.hidden = false;
        }
      });
    });
  }

  var wlDrawerBound = false;
  function initWishlistDrawer() {
    if (wlDrawerBound) return;
    var drawer = qs('[data-wishlist-drawer]');
    if (!drawer) return;
    wlDrawerBound = true;
    var grid = qs('[data-grid]', drawer);
    var empty = qs('[data-empty]', drawer);
    function render() {
      var handles = wlGet();
      grid.innerHTML = '';
      if (!handles.length) { empty.hidden = false; return; }
      empty.hidden = true;
      Promise.all(handles.map(function (h) { return fetchProductByHandle(baseUrl(drawer), h); })).then(function (items) {
        grid.innerHTML = '';
        items.filter(Boolean).forEach(function (p) { grid.appendChild(buildCard(p, null)); });
        wlRefresh(grid);
      });
    }
    function open() { render(); drawer.hidden = false; document.body.classList.add('no-scroll'); }
    function close() { drawer.hidden = true; document.body.classList.remove('no-scroll'); }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-wishlist-open]')) { e.preventDefault(); open(); }
      else if (e.target.closest && e.target.closest('[data-wishlist-close]')) { close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('fg:wishlist-change', function (ev) {
      if (drawer.hidden) return;
      if (!ev.detail.on) {
        var b = qs('[data-handle="' + ev.detail.handle + '"]', grid);
        var c = b ? b.closest('.fgc') : null;
        if (c) c.remove();
        if (!wlGet().length) empty.hidden = false;
      }
    });
  }

  /* Pagina prodotto: pallini del carosello foto (smartphone) */
  function initGallery(scope) {
    qsa('.fgp__gallery', scope).forEach(function (g) {
      if (g.dataset.init) return;
      g.dataset.init = '1';
      var slides = qsa('img, figure', g).filter(function (el) { return el.parentNode === g; });
      if (slides.length < 2) return;
      var dots = document.createElement('div');
      dots.className = 'fgp__dots';
      var btns = slides.map(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fgp__dot' + (i === 0 ? ' is-on' : '');
        b.setAttribute('aria-label', 'Foto ' + (i + 1));
        b.addEventListener('click', function () { g.scrollTo({ left: s.offsetLeft - g.offsetLeft, behavior: 'smooth' }); });
        dots.appendChild(b);
        return b;
      });
      g.parentNode.insertBefore(dots, g.nextSibling);
      var tick = null;
      g.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
          var idx = Math.round(g.scrollLeft / Math.max(1, g.clientWidth));
          btns.forEach(function (b, i) { b.classList.toggle('is-on', i === idx); });
        }, 40);
      }, { passive: true });
    });
  }

  function initCart(scope) {
    qsa('[data-fg-cart]', scope).forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';
      var form = qs('#fg-cart-form', root);
      if (!form) return;
      var upd = qs('[data-cart-update]', form);
      if (upd) upd.hidden = true;
      qsa('[data-qty-step]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = b.parentNode.querySelector('input');
          var v = (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qtyStep, 10);
          input.value = Math.max(0, v);
          if (upd && form.requestSubmit) form.requestSubmit(upd); else form.submit();
        });
      });
      qsa('.fgqty__input', form).forEach(function (i) {
        i.addEventListener('change', function () {
          if (upd && form.requestSubmit) form.requestSubmit(upd); else form.submit();
        });
      });
    });
  }

  function initAll(scope) {
    initCart(scope);
    initGallery(scope);
    initWishlistPage(scope);
    initWishlist(scope);
    initWishlistDrawer();
    initFilters(scope);
    initBrands(scope);
    initHeader(scope);
    initSlideshow(scope);
    initArrivals(scope);
    initFooter(scope);
    initProduct(scope);
    initBundle(scope);
    initRelated(scope);
    initRecent(scope);
  }

  function ready() { initAll(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();

  // Theme editor: reinizializza le sezioni ricaricate
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
